<script lang="ts">
	import { onMount } from 'svelte';
	import { fade } from 'svelte/transition';
	import Button, { Label } from '@smui/button';
	import Textfield from '@smui/textfield';
	import {
		mdiGoogle,
		mdiTwitter,
		mdiEmail,
		mdiLastpass,
		mdiContentSave,
		mdiLabel,
		mdiLogin
	} from '@mdi/js';

	import auth from '$stores/authStore';
	import { goto } from '$app/navigation';
	import CenteredPaper from '$lib/CenteredPaper.svelte';
	import SvgIcon from '$lib/SvgIcon.svelte';
	import Paper, { Content, Title } from '@smui/paper';

	async function doGoogleSignup() {
		const success = await auth.loginWithGoogle(placeId);
		if (success) await redirectToApp();
	}
	async function doTwitterSignup() {
		const success = await auth.loginWithTwitter(placeId);
		if (success) await redirectToApp();
	}
	async function doEmailSignup() {
		if (name && email && password) {
			const newUser = await auth.signUpWithEmail(name, email, password, placeId, isDemo);
			if (newUser) {
				await redirectToApp();
			}
		}
	}
	async function redirectToApp() {
		await auth.waitForFirebase();
		await goto('/app');
	}

	export let name: string = '';
	export let email: string = '';
	export let password: string = '';
	export let isDemo: boolean = false;

	let placeId: string | null;
	if ($auth.isLoggedIn) {
		auth.logout();
	}
	$: errorMessageSanitized = $auth.errorMessage
		?.slice('Firebase: Error (auth/'.length)
		.slice(0, -2)
		.replaceAll('-', ' ');

	onMount(async () => {
		placeId = new URLSearchParams(window.location.search).get('key');
	});
</script>

<CenteredPaper title="Sign up">
	<Button variant="raised" style="margin: 10px 0; width: 100%" on:click={doGoogleSignup}>
		<SvgIcon mdiIcon={mdiGoogle} />
		<Label>Sign Up with Google</Label>
	</Button>
	<Button variant="raised" style="margin: 10px 0; width: 100%" on:click={doTwitterSignup}>
		<SvgIcon mdiIcon={mdiTwitter} />
		<Label>Sign Up with Twitter</Label>
	</Button>

	<Paper color="primary" variant="outlined" style="width:100%">
		<div class="small-title">Sign up with Email</div>
		<form name="signup" method="dialog">
			<Content>
				<div class="signup-form" in:fade>
					<Textfield
						label="Name"
						name="name"
						style="width: 100%"
						helperLine$style="width: 100%;"
						class="outlined"
						variant="outlined"
						bind:value={name}
						input$autocomplete="name" />
					<Textfield
						label="Email"
						name="email"
						style="width: 100%"
						helperLine$style="width: 100%;"
						class="outlined"
						variant="outlined"
						bind:value={email}
						input$autocomplete="email" />
					<Textfield
						label="Password (7 characters minimum)"
						name="password"
						style="width: 100%;"
						helperLine$style="width: 100%;"
						class="outlined"
						variant="outlined"
						type="password"
						bind:value={password}
						input$autocomplete="new-password" />
					{#if $auth.errorOccurred}
						<div class="error-message">Error: {errorMessageSanitized}</div>
					{/if}
					<div class="submit-buttons">
						<Button
							variant="raised"
							style="margin: 10px 0; "
							class="signup-button"
							on:click={doEmailSignup}
							disabled={!name || !email || !password || password.length < 7}>
							<SvgIcon mdiIcon={mdiContentSave} />
							<Label>Submit</Label>
						</Button>
					</div>
				</div>
			</Content>
		</form>
	</Paper>
	<Button
		variant="raised"
		color="secondary"
		style="margin: 10px 0; width: 100%"
		on:click={() => goto('/login')}>
		<SvgIcon mdiIcon={mdiLogin} />
		<Label>Login with an existing account</Label>
	</Button>
</CenteredPaper>

<style>
	.small-title {
		text-align: center;
		font-size: 1.1rem;
		padding-bottom: 10px;
	}
	.signup-form {
		display: flex;
		flex-direction: column;
		width: 100%;
		gap: 10px;
	}
	.submit-buttons {
		display: flex;
		flex-direction: row;
		width: 100%;
		justify-content: space-between;
		gap: 16px;
	}
	.error-message {
		text-align: center;
		color: darkred;
	}
</style>
